import React from 'react';
import {loadLanguage} from 'Utils/jwtUtil';
import util from 'Utils/commonUtil';
// Components
import Anchor from 'Components/common/Anchor';

// Actions
import {T} from 'Actions/translate';

class ProxyDeliveryPackageOnTheGoItem extends React.Component {
    render() {
        const {item, chooseItem, tabActive, statusOptions} = this.props;
        let lang = loadLanguage();
        const statusKey = Array.isArray(statusOptions)
            ? statusOptions
                  .map((option) => option && option.key)
                  .find((key) => key === item.status)
            : null;
        const keyUpper = statusKey ? statusKey.toUpperCase() : '';

        const isHostRejected = keyUpper === 'HOST_REJECTED';
        const isCustomerRejected = keyUpper === 'CUSTOMER_REJECTED';
        const isCompleted = keyUpper === 'COMPLETED';

        return (
            <Anchor onClickOfSingleTap={chooseItem}>
                <div className="header-title row">
                    <h6 className="order-num dn-number text-ellipsis">
                        <label>{T('fone_order_dn_number')}</label>
                        {item.shipmentNumber}
                    </h6>
                    {item.eta && tabActive === 0 ? (
                        <div className="second-column">
                            <label>
                                {T('fone_order_estimated_delivery_time')}
                            </label>
                            <div>{item.eta}</div>
                        </div>
                    ) : null}
                </div>
                <p className="row clearfix">
                    <span className="f1-number text-ellipsis pull-left">
                        <label>
                            {T('proxy_delivery_order_management_order_number')}
                        </label>
                        {item.orderNumber}
                    </span>
                    <span className="branch-name text-ellipsis pull-right">
                        <label>{T('fone_order_branch_name')}</label>
                        {item.branchName}
                    </span>
                </p>
                <p className="text-ellipsis row">
                    <span className="replenishment-time text-ellipsis">
                        <label>
                            {T('proxy_delivery_order_list_create_time')}
                        </label>
                        {item.orderDate}
                    </span>
                    <span className="delivery-time text-ellipsis">
                        <label>{T('fone_order_delivery_time')}</label>
                        {item.shipDate}
                    </span>
                </p>

                {tabActive === 1 && item.stRemark && (
                    <p className="text-ellipsis row">
                        <span className="proxy-delivery-stRemark text-ellipsis">
                            <label>{T('proxy_delivery_shipto_remark')}</label>
                            <div
                                className="stRemark-value"
                                style={{
                                    __html: item.stRemark,
                                }}>
                                {item.stRemark}{' '}
                            </div>
                        </span>
                    </p>
                )}

                {tabActive === 0 && (
                    <p className="carrier-name text-ellipsis row">
                        <label>{T('host_logistics_company')}</label>
                        {item.carrierName}
                    </p>
                )}
                {tabActive === 2 && (
                    <div
                        className={util.getClassName({
                            tag: true,
                            'is-rejected': isHostRejected,
                            'is-customer-rejected': isCustomerRejected,
                            'is-received': isCompleted,
                            'en-is-rejected': lang === 'EN' && isHostRejected,
                            'en-customer-is-rejected':
                                lang === 'EN' && isCustomerRejected,
                            'en-is-received': lang === 'EN' && isCompleted,
                        })}></div>
                )}
            </Anchor>
        );
    }
}

export default ProxyDeliveryPackageOnTheGoItem;
